import * as React from 'react';
import Preloader from './nv-chart/partials/Preloader';
import TypesenseProvider from './nv-chart/partials/typesense/Provider';
import OpenSearchProvider from './nv-chart/partials/opensearch/Provider';
import HiddenDataTable from './nv-chart/partials/HiddenDataTable';

const getInitialGroupFromUrl = (groups) => {
  const urlParams = new URLSearchParams(window.location.search);
  const requestedGroup = urlParams.get('group');
  const matchedGroup = groups.find(group => group.label.toLowerCase() === requestedGroup?.toLowerCase());
  const defaultGroup = groups[0];

  return matchedGroup?.label ?? defaultGroup?.label;
};

const syncGroupToUrl = (groupLabel) => {
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set('group', groupLabel);
  window.history.replaceState({}, '', currentUrl);
};

export default function NvChart(props) {
  const {settings} = props;
  const {title, style, lineStyle, provider, groups = []} = settings;

  // Preview token / index are OpenSearch-only — Typesense has no preview collection.
  const previewIndex = React.useMemo(
    () => (provider === 'opensearch'
      ? document.getElementById('library-preview-token')?.dataset?.index
      : null),
    [provider]
  );
  const resolvedIndex = previewIndex ?? settings.defaultIndex;

  const [groupLabel, setGroupLabel] = React.useState(() => getInitialGroupFromUrl(groups));

  const handleGroupChange = React.useCallback((newLabel) => {
    setGroupLabel(newLabel);
    syncGroupToUrl(newLabel);
  }, []);

  const currentGroup = React.useMemo(
    () => groups.find(g => g.label === groupLabel),
    [groups, groupLabel]
  );

  if (groups.length === 0 || !currentGroup) {
    return <Preloader title='Chart'/>;
  }

  const providerProps = {
    defaultIndex: resolvedIndex,
    currentGroup,
    style,
    lineStyle,
    title,
    groups,
    groupLabel,
    handleGroupChange,
  };

  return (
    <div className='nv-chart-groups'>
      {provider === 'opensearch'
        ? <OpenSearchProvider {...providerProps}/>
        : <TypesenseProvider {...providerProps}/>
      }
      <HiddenDataTable collectionName={settings.defaultIndex}/>
    </div>
  );
}
